import {Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {Button, ButtonProps, FormWithRedirect, SelectInput, useListContext, useNotify,} from "react-admin";
import {FormSaveButton} from "../../components/FormSaveButton";
import {useOptions} from "../../shared/hooks/useOptions";
import {useToggler} from "../../shared/hooks/useToggler";
import {generateError, initInput} from "../../shared/utils";
import IconCancel from "@material-ui/icons/Cancel";
import UpdateIcon from "@material-ui/icons/Update";
import {useState} from "react";
import {client} from "../../dataProvider";


export const UpdateRouteStatusButton = (props: ButtonProps) => {

  const { value, setFalse, setTrue } = useToggler();
  const [loading, setLoading] = useState(false);
  const { selectedIds, refetch } = useListContext();

  const notify = useNotify();
  const handleSubmit = async (e: any) => {

    setLoading(true);

    client(`routes/set_routes_status`, {
      method: "POST",
      data: { ids: selectedIds, status: e.status }
    }).then((response) => {
      notify("Stato giri modificato");
      setFalse()
      refetch()
    })
      .catch((error) => {
        generateError(error, notify);
      })
      .finally(() => {
        setLoading(false);
      })

      ;
    refetch();

  };

  const { data: options } = useOptions("routes", "GET");
  return options ? (
    <>
      <Button tabIndex={-1} label="Modifica stato" onClick={() => setTrue()}>
        <UpdateIcon />
      </Button>
      <Dialog open={value} maxWidth="sm" fullWidth>
        <FormWithRedirect
          save={handleSubmit}
          render={({ handleSubmitWithRedirect, pristine, saving, form }) => (
            <>
              <DialogContent>

                <SelectInput
                  {...initInput("status", options, true, "array")}
                  choices={[{ value: "C", display_name: "Completato" }]}
                  value={"C"}
                  defaultValue={"C"}
                  required={true}
                />


              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={setFalse}>
                  <IconCancel />
                </Button>
                <FormSaveButton
                  handleSubmit={() => handleSubmitWithRedirect!()}
                  submitting={loading}
                  pristine={pristine}
                  label="Aggiorna"
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  ) : null;
};
